import { useEffect } from "react";

export const usePromise = (promise: any, setter: any) => {
    useEffect(() => {
        promise.then((result: any) => {
            setter(result);
        });
    }, [promise]);
};
